export enum CourseHiddenStatus {
  UNPUBLISHED = 'UNPUBLISHED', //Course is not yet available except test mode, UI should indicate not available
  REMOVED = 'REMOVED', //Course is no longer available to anyone, except in test mode, UI should indicate removal
  HIDDEN = 'HIDDEN', //Course is no longer available to anyone, except in test mode, or if a user has a license
  PUBLISHED = 'PUBLISHED' //Course is available to everyone
}
